import React, { useEffect, useState } from "react";
import logo from "../../../../../Assets/Image/Thebook24.svg";
import img from "../../../../../Assets/Image/paidStamp.png"
import img2 from "../../../../../Assets/Image/codStamp.png"

const OrderPrint = ({ isOpen, orders, onClose }) => {
    const [isDisabled, setIsDisabled] = useState(true);

    const handlePrint = () => {
        const printWindow = window.open('', '_blank'); // Open a new window for printing
        const content = document.querySelector('.printingContainer').innerHTML;

        printWindow.document.write(`
            <html>
                <head>
                    <style>
                        body{
                        display:flex;
                        justify-content:center;
                        align-item:center;

                        }
                        .packing-slip {
                            font-family: Arial, sans-serif;
                            color: #333;
                            padding: 5px 10px;
                            background: white;
                            width: 98%;
                            margin: 0 auto;
                            page-break-after: always;
                             break-inside: avoid;
                        }
                        .packing-slip:last-child{
                        page-break-after: auto;
                        }
                        .printer-button h1 {
                            background-color: white;
                            padding: 5px 10px;
                            font-size: 1.3rem;
                            border-radius: 5px;
                        }
    
                        .printer-button {
                            padding-top: 15px;
                            position: sticky;
                            top: 0;
                            left: 0;
                            right: 45px;
                            bottom: 0;
                            display: flex;
                            justify-content: end;
                            z-index: 1002;
                            height: 100vh;
                        }
                        
                        .packing-slip-header {
                            display: flex;
                            justify-content: space-between;
                            border-bottom: 2px solid #000;
                        }
    
                        .packing-slip-title {
                            font-size: 24px;
                            font-weight: bold;
                        }
    
                        .packing-slip-order-details {
                            text-align: right;
                        }
    
                        
                        .packing-slip-address {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 5px;
                        }
    
                        .packing-slip-ship-to,
                        .packing-slip-bill-to {
                            width: 45%;
                        }
    
                         h3 {
                            font-size: 18px;
                            margin-bottom: 5px;
                        }
    
                         .bill {
                            font-size: 18px;
                            margin-bottom: 5px;
                            display: flex;
                            justify-content: center;
                        }
    
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
    
                        th,
                        td {
                            text-align: left;
                            padding: 8px;
                            border: 1px solid #ddd;
                        }
    
                        .packing-slip-item-details {
                            display: flex;
                            align-items: center;
                        }
    
                        .packing-slip-item-image {
                            width: 50px !important;
                            height: 50px;
                            margin-right: 10px;
                        }

                        .packing-slip-footer {
                            text-align: center;
                            font-size: 14px;
                        }
                        .page-break {
                            page-break-before: always; 
                        }
                        
                        .printingContainer {
                            visibility: visible;
                            width: 100%;
                            padding: 10px;
                            top: 0;
                            left: 0;
                        }
    
                        .printer-button {
                            display: none;
                        }
                            .td{
                            width:10%;
                            }
                        .packing-slip .summary{
                             margin-top: 20px;
                        }
                        .packing-slip .summary-row{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                             border-bottom:1px grey solid;
                             padding: 10px 0px;
                        }
                               .center-invoice-title {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: relative;
                        }
                        
                        .center-invoice-title::before,
.center-invoice-title::after {
    content: "";
    flex: 1;
    height: 1px;
    border-top: 1px dashed #333; /* Dashed line */
    margin: 0 10px;
}
                        
                    </style>
                </head>
                <body>
                    <div class="printingContainer">
                        ${content} <!-- Inject the orders content here -->
                    </div>
                </body>
            </html>
        `);
        printWindow.document.close(); // Close the document to finish writing
        printWindow.print(); // Trigger the print dialog
    };
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => {
                setIsDisabled(false);
            }, 5000);
        }
    }, [isOpen]);

    if (!isOpen) return null

    return (
        <>
            <div className="main-printer" onClick={() => onClose()}>
            <button
    className="printer-button"
    style={{
        zIndex: 10000000,
        cursor: isDisabled ? "not-allowed" : "pointer",
        right: "150px",
        backgroundColor: isDisabled ? "" : "",
       
    }}
    disabled={isDisabled}
    onClick={!isDisabled ? handlePrint : undefined}
>
    <h1>Print</h1>
</button>
                <button className="printer-button" style={{ zIndex: 10000000, cursor: "pointer" }} onClick={() => onClose()}><h1 onClick={() => onClose()}>cancel</h1></button>
                <div className="modal-printer" style={{ overflow: "scroll" }} >
                    <div className="flex printingContainer" >
                        {
                            orders.map((itm) => {
                                return (
                                    <>
                                        <div className="packing-slip page-break" >
                                            {/* Header */}
                                            <header className="packing-slip-header">
                                                <h1 className="packing-slip-title" style={{ display: "flex", alignItems: "center" }}><img src={logo} alt="logo" style={{ width: "18%" }} loading="lazy" /> THE BOOKS 24</h1>
                                                <div className="packing-slip-order-details">
                                                    <p><strong>Order #</strong> {itm.orderId}</p>
                                                    <p><strong>Date:</strong> {new Date(itm?.orderAt).toLocaleDateString('en-US', {
                                                        year: 'numeric',
                                                        month: 'long',
                                                        day: 'numeric',
                                                    })}</p>
                                                </div>
                                            </header>

                                            {/* Address Section */}
                                            <section className="packing-slip-address" style={{ display: "flex", justifyContent: "space-between", alignItems: "start", width: "100%" }}>
                                                <div className="packing-slip-ship-to">
                                                    <h3>SHIP TO</h3>
                                                    <p>Name: {itm?.customerAddressDetail?.firstName} {itm?.customerAddressDetail?.lastName}</p>
                                                    {/* <p>{itm?.customerAddressDetail?.addressLine1}{itm?.customerAddressDetail?.addressLine1}</p> */}

                                                    <p>Address: {itm?.customerAddressDetail?.addressLine1}, {itm?.customerAddressDetail?.landMark}</p>
                                                    <p>City: {itm?.customerAddressDetail?.cityTitle}</p>
                                                    <p>PinCode: {itm?.customerAddressDetail?.pinCode}</p>
                                                    <p>State: {itm?.customerAddressDetail?.stateTitle}</p>
                                                    <p>Mobile Number: {itm?.customerAddressDetail?.mobileNumber}</p>
                                                </div>
                                                <div className="packing-slip-bill-to">
                                                    <h3>FROM TO</h3>
                                                    <p>Mukul Sharma ,
                                                    </p>
                                                    <p>
                                                        Shri Shyam Book Depot ,
                                                    </p>
                                                    <p>Address: Main Kanta Circle, kharini phatak road, jhotwara, jaipur-302012</p>
                                                    <p>Mobile Number: 9782938018</p>
                                                </div>
                                            </section>

                                            <div className="center-invoice-title">
                                                <h2>Invoice</h2>
                                            </div>

                                            {/* Items Table */}
                                            <section className="packing-slip-items">
                                                <h3>{itm?.standardDelivery ? "Standard Delivery" : "Express Delivery"} / Payment Type:- {itm?.paymentType}</h3>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Item</th>
                                                            <th>Price</th>
                                                            <th>Quantity</th>
                                                            <th>Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itm.itemDetailList?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="packing-slip-item-details">
                                                                        <img src={item.itemImageUrls?.[0]} alt={item.name} className="packing-slip-item-image" loading="lazy" />
                                                                        <p>{item.title}</p>
                                                                        {/* <p><strong>SKU:</strong> {item.sku}</p> */}
                                                                    </div>
                                                                </td>
                                                                <td className="td">{item.sellingPrice}</td>
                                                                <td className="td">{item.quantity}</td>
                                                                <td className="td">{item.quantity * item.sellingPrice}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </section>
                                            <div className="summary">
                                                <div className="summary-row">
                                                    <span>Sub Total</span>
                                                    <span>{itm?.subTotal}</span>
                                                </div>
                                                <div className="summary-row">
                                                    <span>Coupon Discount</span>
                                                    <span className="negative">{itm?.couponDiscountAmount}</span>
                                                </div>
                                                <div className="summary-row">
                                                    <span>Delivery Charges</span>
                                                    <span className="negative">{itm?.deliveryCharges + itm?.packingCharges}</span>
                                                </div>
                                                <div className="summary-row total">
                                                    <span>Order Total</span>
                                                    <span className="negative">{itm?.orderTotal}</span>
                                                </div>
                                                <div className="paid-stamp" style={{ position: 'relative', textAlign: 'center' }}>
                                                    {itm?.paymentType === 'ONLINE' ? (

                                                        <img
                                                            src={img}
                                                            alt="Paid Stamp"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-60px',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                width: '150px',
                                                                opacity: '0.8',
                                                            }}
                                                        />

                                                    ) :
                                                        (
                                                            <img
                                                                src={img2}
                                                                alt="COD Stamp"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-60px',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    width: '215px',
                                                                    opacity: '0.8',
                                                                }}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* Footer */}
                                            <footer className="packing-slip-footer">
                                                <p>Thank you for shopping with us!</p>
                                                <p><strong>The Books24</strong></p>
                                                <p>Shri Shyam Book Depot, Jhotwara, Jaipur, Rajasthan</p>
                                                <p>thebooks24india@gmail.com</p>
                                            </footer>
                                        </div>
                                    </>
                                )
                            })
                        }

                    </div>
                </div>

            </div>
        </>
    );
};

export default OrderPrint;